import axios from '../../../../../../node_modules/axios/lib/axios.js';
import {reactive} from 'vue';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.withCredentials = true;

export default class API {
    static status = reactive({
        loading: false
    });

    static eventNames = {
        'add': 'CART_ADD',
        'removeItem': 'CART_DELETE'
    }

    static getBaseUrl = (url) => {
        return import.meta.env.VITE_APP_URL + (url ? '/' + url : '');
    }

    static getLangCode = () => {
        return document.getElementsByTagName('html')[0].attributes.lang.value || 'en';
    }

    static buildUrl = (url) => {
        if (/^https?:\/\//i.test(url)) {
            return url;
        }

        const lang = this.getLangCode();

        if (lang === 'en') {
            return url;
        }

        if (url.startsWith('/api/')) {
            const alreadyHasLang = new RegExp(`^/${lang}/api/`).test(url);
            if (alreadyHasLang) {
                return url;
            }

            return `/${lang}${url}`;
        }

        return url;
    }

    static get = (url) => {
        const finalUrl = this.buildUrl(url);

        return new Promise((resolve, reject) => {
            axios({
                method: "get",
                url: finalUrl,
                responseType: "json"
            }).then(response => {
                resolve(response.data);
            }, response => {
                reject(response);
            });
        });
    }

    static post = (url, data, callback, callbackError) => {
        console.log('axios post');

        const finalUrl = this.buildUrl(url);

        return new Promise((resolve, reject) => {
            axios({
                method: "post",
                url: finalUrl,
                data: data,
                responseType: "json"
            }).then(response => {
                resolve(response.data);
            }, errorResponse => {
                console.log('axios error', errorResponse);
                reject(errorResponse);
            });
        });
    }

    static emitEvent(url) {
        if (window.eventBus && this.eventNames[url]) {
            window.eventBus.emit(this.eventNames[url]);
        }
    }

    static loading = () => {
        this.status.loading = true;
    }

    static loadingComplete = () => {
        this.status.loading = false;
    }

    static isLoading = () => {
        return this.status.loading;
    }

    static getTranslations() {
        const cacheBuster = `cb=${new Date().getTime()}`;
        const lang = API.getLangCode();

        return new Promise((resolve, reject) => {
            API.get(`/build/i18n/${lang}.json?${cacheBuster}`)
                .then(result => {
                    window.translations = result;
                    resolve(result);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
}
